export function normalizePhoneDigits(value: string): string {
  return value.replace(/\D/g, '')
}

export function phoneTelHref(value: string): string {
  const digits = normalizePhoneDigits(value)
  if (!digits) return ''

  if (digits.startsWith('375')) return `+${digits}`
  if (digits.startsWith('7') && digits.length === 11) return `+${digits}`
  if (digits.startsWith('8') && digits.length === 11) return `+7${digits.slice(1)}`

  return `+${digits}`
}

export function formatPhoneDisplay(value?: string | null): string {
  const raw = value?.trim() ?? ''
  if (!raw) return ''

  if (/[\s()+\-]/.test(raw) && normalizePhoneDigits(raw).length < 9) {
    return raw
  }

  let digits = normalizePhoneDigits(raw)

  if (digits.startsWith('80') && digits.length === 11) {
    digits = `375${digits.slice(2)}`
  }

  if (digits.startsWith('375') && digits.length === 12) {
    const rest = digits.slice(3)
    return `+375 (${rest.slice(0, 2)}) ${rest.slice(2, 5)}-${rest.slice(5, 7)}-${rest.slice(7, 9)}`
  }

  if (digits.length === 9 && /^[29]\d{8}$/.test(digits)) {
    return `+375 (${digits.slice(0, 2)}) ${digits.slice(2, 5)}-${digits.slice(5, 7)}-${digits.slice(7, 9)}`
  }

  if (digits.startsWith('8') && digits.length === 11) {
    digits = `7${digits.slice(1)}`
  }

  if (digits.startsWith('7') && digits.length === 11) {
    const rest = digits.slice(1)
    return `+7 (${rest.slice(0, 3)}) ${rest.slice(3, 6)}-${rest.slice(6, 8)}-${rest.slice(8, 10)}`
  }

  if (digits.length === 10 && digits.startsWith('9')) {
    return `+7 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`
  }

  if (/[\s()+\-]/.test(raw)) return raw

  return raw
}
